import Grid from '@mui/material/Grid2';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Chip, IconButton, Stack } from '@mui/material';
import { Download } from '@mui/icons-material';
import { getFatture } from '../../../redux/noleggi/operations';
import { formatStringDate } from '../../../utils/formadDate';
import { formatCurrency } from '../../../utils/formatNumber';

export default function FattureTable({
  onOpenRichiesta,
  onDownload,
  pageSize = 20,
}) {
  const dispatch = useDispatch();

  const { fatture, getFattureAction } = useSelector(state => state.noleggi);
  useEffect(() => {
    dispatch(getFatture());
  }, []);

  const columns = [
    {
      field: 'data',
      headerName: 'Data',
      flex: 1,
      maxWidth: 130,
      valueFormatter: value => {
        return formatStringDate(value);
      },
    },
    {
      field: 'titolo',
      headerName: 'Titolo',
      flex: 1,
    },
    {
      field: 'importo',
      headerName: 'Importo',
      headerClassName: 'align-right',
      flex: 1,
      maxWidth: 150,
      renderCell: params => {
        return (
          <Stack sx={{ textAlign: 'end', height: '100%' }}>
            {formatCurrency(params.row.importo)}
          </Stack>
        );
      },
    },
    {
      field: 'flg_pagato',
      headerName: 'Pagato',
      flex: 1,
      maxWidth: 150,
      renderCell: params => {
        return (
          <Stack
            sx={{
              justifyContent: 'center',
              height: '100%',
              alignItems: 'center',
            }}
          >
            <Box>
              {params.value ? (
                <Chip label="Pagato" color="success" size="small" />
              ) : (
                <Chip label="Non Pagato" color="error" size="small" />
              )}
            </Box>
          </Stack>
        );
      },
    },
    {
      field: 'azioni',
      headerName: 'Azioni',
      sortable: false,
      headerClassName: 'no-separator',
      cellClassName: 'no-separator',
      disableColumnMenu: true,
      renderCell: params => (
        <Stack
          flexDirection="row"
          gap={1}
          sx={{
            justifyContent: 'start',
            height: '100%',
            alignItems: 'center',
          }}
        >
          <IconButton
            size="small"
            sx={{
              border: 'none',
              backgroundColor: 'transparent',
            }}
            onClick={() => onDownload(params.row)}
          >
            <Download />
          </IconButton>
        </Stack>
      ),
    },
  ];

  return (
    <Grid container spacing={2} columns={12}>
      <Grid size={{ md: 12, lg: 12 }} sx={{ width: '100%' }}>
        <DataGrid
          onRowDoubleClick={params => onOpenRichiesta(params.row)}
          autoHeight
          rows={fatture}
          columns={columns}
          loading={getFattureAction.loading}
          getRowClassName={params =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          initialState={{
            pagination: { paginationModel: { pageSize: pageSize } },
          }}
          pageSizeOptions={[10, 20, 50]}
          disableColumnResize
          density="standard"
        />
      </Grid>
    </Grid>
  );
}
